import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import {
  EventDispatchSucceededPayloadInterface,
  EventDispatchFailedPayloadInterface,
} from './interfaces';
import { providerSlice } from '../provider';
import { MixpanelStateInterface } from './interfaces/mixpanel-state-interface.ts';
export type * from './interfaces';

export const initialState: MixpanelStateInterface = {
  status: 'Uninitialized' as const,
  token: '',
};

export const mixpanelSlice = createSlice({
  name: 'mixpanel',
  initialState: { ...initialState },
  extraReducers: (builder) => {
    builder.addCase(providerSlice.actions.initializeProviderStateSucceeded, (state, action) => {
      const token =
        action.payload.providerSettings.data?.mixpanelSettings?.find(
          (setting) => setting.app === 'go',
        )?.token ?? '';

      if (!token.trim()) {
        return { ...state };
      }

      return {
        ...state,
        status: 'Initialized',
        token,
      };
    });
  },
  reducers: {
    eventDispatchSucceeded(state, _: PayloadAction<EventDispatchSucceededPayloadInterface>) {
      return { ...state };
    },
    eventDispatchFailed(state, _: PayloadAction<EventDispatchFailedPayloadInterface>) {
      return { ...state };
    },
  },
});
